import { Controller, Control, FieldValues, Path } from 'react-hook-form';
import { PhoneNumberInputV2 } from 'shared-components';

interface Props<T extends FieldValues> {
  id: string;
  control: Control<T>;
  name?: Path<T>;
  label?: string;
  // Allow extra props (e.g., showErrorsOnlyAfterSubmit) without typing errors
  [key: string]: any;
}

export const PhoneNumberInputRHF = <T extends FieldValues>({ id, control, name, label = '' }: Props<T>) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
      const [code = '', phone = ''] = (value ?? '').split('-');
      const err = error?.message;
      return (
        <PhoneNumberInputV2
          id={id}
          label={label}
          codeValue={code}
          numberValue={phone}
          forwardedRef={ref}
          onChangeCode={e => onChange(`${e.currentTarget.value}-${phone}`)}
          onChangeNumber={e => onChange(`${code}-${e.currentTarget.value}`)}
          errorTextCode={err}
          errorTextNumber={err}
        />
      );
    }}
  />
);
